// Keep this constant local so the gameengine chat path does not pull in
// UI/i18n helpers from `@core/utils/skyxChatWinShare` during module init.
const SKYX_WIN_SHARE_PREFIX = '@skyx-win:';

/** Max length for free-form chat messages (matches Aviator). */
export const CHAT_MESSAGE_MAX_LENGTH = 160;

export function isStructuredChatPayload(text: string): boolean {
  return text.trim().startsWith(SKYX_WIN_SHARE_PREFIX);
}

export function clampChatMessage(
  text: string,
  maxLength: number = CHAT_MESSAGE_MAX_LENGTH
): string {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength);
}

/** Trim and enforce length for outgoing chat text; structured payloads are exempt. */
export function normalizeOutgoingChatMessage(text: string): string | null {
  const trimmed = text.trim();
  if (!trimmed) return null;
  if (isStructuredChatPayload(trimmed)) return trimmed;
  const clamped = clampChatMessage(trimmed);
  return clamped || null;
}
